import common from 'locales/fr/common.json';
import admin from 'locales/fr/pages/admin.json';
import navigation from 'locales/fr/navigation.json';
import home from 'locales/fr/pages/home.json';
import company from 'locales/fr/pages/company.json';
import transactions from 'locales/fr/pages/transactions.json';
import support from 'locales/fr/pages/support.json';
import genericItem from 'locales/fr/pages/genericItem.json';
import myClients from 'locales/fr/pages/myClients.json';
import calendar from 'locales/fr/pages/calendar.json';
import auth from 'locales/fr/auth.json';
import financialCenter from 'locales/fr/financialCenter.json';
import forms from 'locales/fr/forms.json';
import profile from 'locales/fr/pages/profile.json';
import commissions from 'locales/fr/pages/advisorReports.json';
import searchPage from 'locales/fr/pages/search.json';
import downloadError from 'locales/fr/downloadError.json';

export const resources = {
  common,
  navigation,
  home,
  company,
  transactions,
  support,
  genericItem,
  myClients,
  calendar,
  auth,
  admin,
  financialCenter,
  forms,
  profile,
  commissions,
  searchPage,
  downloadError,
} as const;
